/**
 * @module geo/middleware
 */
import {Action} from 'redux';
import {Epic} from 'redux-observable';
import {Observable} from 'rxjs';
import {Action as ActionFsa, isType} from 'typescript-fsa';

import {gotoExtentAsyncCreator, gotoExtentCreator, gotoInitExtentAsyncCreator, gotoInitExtentCreator, gotoPointAsyncCreator, gotoPointCreator, panToAsyncCreator, panToCreator, zoomInAsyncCreator, zoomInCreator, zoomOutAsyncCreator, zoomOutCreator, zoomToScaleAsyncCreator, zoomToScaleCreator} from '../actions/creators';
import busService from '../bus';
import {GO_TO_EXTENT, GO_TO_INIT_EXTENT, PAN_TO, ZOOM_IN, ZOOM_OUT, ZOOM_TO_SCALE} from '../payload/facade';
import {GO_TO_POINT} from '../payload/facade/GO_TO_POINT';
import {ExtentDone} from '../payload/response';
import {AppStore} from '../store/app';

/**
 * @private
 *
 */
export const zoomInEpic: Epic<Action, AppStore> = (action$, store, uid) =>
    action$.filter(action => isType(action, zoomInCreator))
        .mergeMap((action) => {
          const uid = store.getState().uid;
          const actionFsa = action as ActionFsa<ZOOM_IN>;
          return Observable
              .fromPromise(busService.geoBus.sendP<ExtentDone>(
                  zoomInAsyncCreator.type, actionFsa.payload,
                  store.getState().uid))
              .map(result => zoomInAsyncCreator.done({
                params: actionFsa.payload,
                result: {done: true, extent: result.data.extent}
              }))
              .catch(error => {
                return Observable.of(zoomInAsyncCreator.failed(
                    {params: actionFsa.payload, error}));
              });
        });

/**
 * @private
 *
 */
export const zoomOutEpic: Epic<Action, AppStore> = (action$, store, uid) =>
    action$.filter(action => isType(action, zoomOutCreator))
        .mergeMap((action) => {
          const actionFsa = action as ActionFsa<ZOOM_OUT>;
          return Observable
              .fromPromise(busService.geoBus.sendP<ExtentDone>(
                  zoomOutAsyncCreator.type, actionFsa.payload,
                  store.getState().uid))
              .map(result => zoomOutAsyncCreator.done({
                result: {done: true, extent: result.data.extent},
                params: actionFsa.payload
              }))
              .catch(error => {
                return Observable.of(zoomOutAsyncCreator.failed(
                    {params: actionFsa.payload, error}));
              });
        });
/**
 * @private
 *
 */
export const pantToEpic: Epic<Action, AppStore> = (action$, store, uid) =>
    action$.filter(action => isType(action, panToCreator))
        .mergeMap((action) => {
          const actionFsa = action as ActionFsa<PAN_TO>;
          return Observable
              .fromPromise(busService.geoBus.sendP<ExtentDone>(
                  panToAsyncCreator.type, actionFsa.payload,
                  store.getState().uid))
              .map(result => zoomOutAsyncCreator.done({
                result: {done: true, extent: result.data.extent},
                params: actionFsa.payload
              }))
              .catch(error => {
                return Observable.of(zoomOutAsyncCreator.failed(
                    {params: actionFsa.payload, error}));
              });
        });

/**
 * @private
 *
 */
export const gotoInitExtentEpic: Epic<Action, AppStore> =
    (action$, store, uid) =>
        action$.filter(action => isType(action, gotoInitExtentCreator))
            .mergeMap((action) => {
              const actionFsa = action as ActionFsa<GO_TO_INIT_EXTENT>;
              return Observable
                  .fromPromise(busService.geoBus.sendP<ExtentDone>(
                      gotoInitExtentAsyncCreator.type, actionFsa.payload,
                      store.getState().uid))
                  .map(result => zoomOutAsyncCreator.done({
                    result: {done: true, extent: result.data.extent},
                    params: actionFsa.payload
                  }))
                  .catch(error => {
                    return Observable.of(zoomOutAsyncCreator.failed(
                        {params: actionFsa.payload, error}));
                  });
            });
/**
 * @private
 *
 */
export const gotoExtentEpic: Epic<Action, AppStore> = (action$, store, uid) =>
    action$.filter(action => isType(action, gotoExtentCreator))
        .mergeMap((action) => {
          const actionFsa = action as ActionFsa<GO_TO_EXTENT>;
          return Observable
              .fromPromise(busService.geoBus.sendP<ExtentDone>(
                  gotoExtentAsyncCreator.type, actionFsa.payload,
                  store.getState().uid))
              .map(result => gotoExtentAsyncCreator.done({
                result: {done: true, extent: result.data.extent},
                params: actionFsa.payload
              }))
              .catch(error => {
                return Observable.of(gotoExtentAsyncCreator.failed(
                    {params: actionFsa.payload, error}));
              });
        });

/**
 * @private
 *
 */
export const gotoPointEpic: Epic<Action, AppStore> = (action$, store, uid) =>
    action$.filter(action => isType(action, gotoPointCreator))
        .mergeMap((action) => {
          const actionFsa = action as ActionFsa<GO_TO_POINT>;
          return Observable
              .fromPromise(busService.geoBus.sendP<ExtentDone>(
                  gotoPointAsyncCreator.type, actionFsa.payload,
                  store.getState().uid))
              .map(result => gotoPointAsyncCreator.done({
                result: {done: true, extent: result.data.extent},
                params: actionFsa.payload
              }))
              .catch(error => {
                return Observable.of(gotoPointAsyncCreator.failed(
                    {params: actionFsa.payload, error}));
              });
        });

/**
 * @private
 *
 */
export const zoomToScaleEpic: Epic<Action, AppStore> = (action$, store, uid) =>
    action$.filter(action => isType(action, zoomToScaleCreator))
        .mergeMap((action) => {
          const actionFsa = action as ActionFsa<ZOOM_TO_SCALE>;
          return Observable
              .fromPromise(busService.geoBus.sendP<ExtentDone>(
                  zoomToScaleAsyncCreator.type, actionFsa.payload,
                  store.getState().uid))
              .map(result => zoomToScaleAsyncCreator.done({
                result: {done: true, extent: result.data.extent},
                params: actionFsa.payload
              }))
              .catch(error => {
                return Observable.of(zoomToScaleAsyncCreator.failed(
                    {params: actionFsa.payload, error}));
              });
        });